<script setup lang="ts">
import { onMounted, defineAsyncComponent } from 'vue';
import i18n from '@/localization/i18n';
import BusinessRequestProgressBar from "./BusinessRequestProgressBar.vue";
import { storeToRefs } from 'pinia';
import { useBusinessRequestFormStore } from '@/pages/index/stores/business-request-form-store';
import { logNewEvent } from '@/services/modules/firebase';

const businessRequestFormStore = useBusinessRequestFormStore()
const { urgencyFormData, urgencyFormErrors} = storeToRefs(businessRequestFormStore)
const Fire = defineAsyncComponent(() => import('vue-material-design-icons/Fire.vue'))
const WhitebalanceSunny = defineAsyncComponent(() => import('vue-material-design-icons/WhiteBalanceSunny.vue'))
const SnowflakeVariant = defineAsyncComponent(() => import('vue-material-design-icons/SnowflakeVariant.vue'))

const t = i18n.global.t

onMounted(() => {
    urgencyFormErrors.value.urgency = ""
})
</script>

<template>
    <div class="rounded main fullHeight" style="height: 550px">
        <BusinessRequestProgressBar />
        <div class="fullRemainingHeight">
            <div class="expanded">
                <div class="h-style h3-style use-poppins text-center mt-4">
                    {{ t("w_txt_business_request_when_needed") }}
                </div>
                <div class="mt-4 mx-md-5">
                    <p class="">
                        {{ t("w_txt_business_request_urgency_level") }}
                    </p>
                </div>

                <div class="card shadow rounded-4 mt-5 py- px-4 w-100">
                    <div class="card-content">
                        <div class="mb-2 flex-space-between" >
                            <div class="form-check">
                                <input class="form-check-input" v-model="urgencyFormData.urgency" type="radio" name="exampleRadios" id="choice1" value="g_lst_bizreq_urgency_1_high">
                                <label class="form-check-label" for="choice1">
                                    {{ t('g_lst_bizreq_urgency_1_high') }}
                                </label>
                            </div>
                            <fire :size="25" class="fire" />
                        </div>

                        <div class="mb-2 flex-space-between">
                            <div class="form-check">
                                <input class="form-check-input" v-model="urgencyFormData.urgency" type="radio" name="exampleRadios" id="choice2" value="g_lst_bizreq_urgency_2_std" >
                                <label class="form-check-label" for="choice2">
                                    {{ t('g_lst_bizreq_urgency_2_std') }}
                                </label>
                            </div>
                            <whitebalance-sunny :size="25" class="whitebalance-sunny" />
                        </div>
                        <div class="mb-2 flex-space-between">
                            <div class="form-check">
                                <input class="form-check-input" v-model="urgencyFormData.urgency" type="radio" name="exampleRadios" id="choice3" value="g_lst_bizreq_urgency_3_flex" >
                                <label class="form-check-label" for="choice3">
                                    {{ t('g_lst_bizreq_urgency_3_flex') }}
                                </label>
                            </div>
                            <snowflake-variant :size="25" class="snowflake-variant" />
                        </div>
                    </div>
                </div>
                <p class="mb-0 text-danger mt-2 error-text ms-2" v-if="urgencyFormErrors.urgency">{{ urgencyFormErrors.urgency }}</p>
            </div>
            <div style="margin-top: auto; margin-bottom:15px ">
                <button @click="businessRequestFormStore.prev_step('title')" type="button" class="btn btn-outline-secondary on-action-btn me-3 mt-2 mb-2 custom-btn-width">
                    {{ t("w_act_business_request_previous") }}
                </button>

                <button @click="() => { logNewEvent('presta_request_submit_urgency'); businessRequestFormStore.next_step('address')  }"
                    type="button" 
                    class="btn btn-primary mt-2 mb-2 on-action-btn custom-btn-width"
                    :disabled="urgencyFormData.urgency.length == 0"
                    :class="{ 'invalid-btn-style': urgencyFormData.urgency.length == 0}"
                    >
                    {{ t("w_act_business_request_next") }}
                </button>
            </div>
        </div>

    </div>
</template>

<style scoped>
.form-check-input[type="radio"] {
    border-color: gray;
}
.btn-primary:focus{
    background-color: #FEB23C !important;
}
.error-text {
    text-align: left;
}
.fire{
    color: red;
}
.whitebalance-sunny{
    color: #FEB23C;
}
.snowflake-variant{
    color: #49AFDA;
}
.flex-space-between {
    display: flex;
    justify-content: space-between; 
    align-items: center; 
}

.card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;  
    padding: 1rem;            
}

.card-content{
    width: 100% !important;
}

.card-content p {
    text-align: left;
    margin-bottom: 0px;         
}

.main {
    padding-top: 15px;
    position: relative;
}

.bg {
    background-color: #FEB23C !important;
}

.fullHeight {
    height: 100%;
    z-index: 1px;
    border: none !important;
    display: flex;                  
    flex-direction: column;
}

.fullRemainingHeight {
    display: flex;                  
    flex-direction: column; 
    height: 100%;  
}

.expanded{
    flex-grow: 1;
    margin-left: 10px;
    margin-right: 10px;
}

.custom-btn-width {
    min-width: 130px;
}

/* Medium devices (md) - 768px and up */
@media (min-width: 768px) {
    /* Styles for medium screens */
    .expanded{
        margin-left: 50px !important;
        margin-right: 50px !important;
    }

    .custom-btn-width {
        min-width: 150px !important;
    }
}


</style>